module.exports = __webpack_public_path__ + "img/bee__4.e186574f.svg";